import { ChangePasswordModel } from '.';
import { formatMessage } from 'src/api';
import MESSAGES from 'src/app/Pages/Home/Reset-Password/ResetPassword.messages';

export const changePasswordFormData = (): ChangePasswordModel => ({
  oldPassword: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.changePwOldError}),
    label: formatMessage({...MESSAGES.changePwOldLabel}),
    name: 'oldPassword',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.changePwOldPlaceholder}),
    required: true,
    validation: 'isPassword',
    value: '',
  },
  newPassword: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.changePwNewError}),
    label: formatMessage({...MESSAGES.changePwNewLabel}),
    name: 'newPassword',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.changePwNewPlaceholder}),
    required: true,
    validation: 'isPassword',
    value: '',
  },
  password: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.changePwNewRepeatError}),
    label: formatMessage({...MESSAGES.changePwNewRepeatLabel}),
    name: 'password',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.changePwNewRepeatPlaceholder}),
    required: true,
    validation: 'password.Repeat',
    value: '',
  },
});
